import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SearchContentField from '../../../../universal/search-content-field/search-content-field.component'
import TeamTable from './table'
import { TableLoader } from '../../../../library/table-loader'
import EmptyTableView from '../../../../universal/empty-table'
import { UpperRow } from '../../../../library/upper-row'
import { SolidButton } from '../../../../library/button'
import { changeCompanyModal } from '../../../../../redux/actions/company'
import './style.scss'

const Index = () => {

    const dispatch = useDispatch()

    const loading = useSelector(state => state.company.fetchFullTeam.loading)
    const detailsLoading = useSelector(state => state.company.fetchDetails.loading)
    const team = useSelector(state => state.company.team)
    const [searchQuery, setSearchQuery] = useState("");
	
    const searchTeam = e => {
        setSearchQuery(e.target.value)
    }

    const clickAddUser = () => {
        dispatch(changeCompanyModal({addMember: true}))
    }

    const renderMainButtons = () => {
        if(!detailsLoading && !loading){
            return [
                <SolidButton onClick={() => clickAddUser()} color="green" icon={<i class="fad fa-plus"></i>} title="Legg til bruker"/>
            ]
        }
        return null
    }

    return(
        <div className="dashboard-company-team-container">
           <div className="inner-dashboard-company-team-container">
            <UpperRow title="Ditt team" buttons={renderMainButtons()}/>
            <SearchContentField searchQuery={searchQuery} handleSearch={searchTeam}/>
            <TeamTable searchQuery={searchQuery}/>
            {loading || detailsLoading ? <TableLoader/>:null}
            {!loading && !detailsLoading && team.length === 0 ? <EmptyTableView title="Ingen medlemmer å vise" description="Her var det veldig tomt, men slapp helt av! Du kan enkelt legge til et nytt medlem ved å trykke på knappen øverst til høyre."/>:null}
           </div>
       </div>
    )
}

export default Index
